//  ———————————————————————— 重复业务 ————————————————————————————
// 微信支付
function payLast (target) {
  target.$vux.loading.hide()
  let data = target.params
  function onBridgeReady () {
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
        appId: data.appId,     // 公众号名称，由商户传入
        timeStamp: data.timeStamp,         // 时间戳，自1970年以来的秒数
        nonceStr: data.nonceStr, // 随机串
        'package': data.packageValue,
        signType: data.signType,       // 微信签名方式：
        paySign: data.paySign   // 微信签名
      },
      function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          WeixinJSBridge.invoke('closeWindow', {}, function (res) {
          })
        }
      })
  }
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
    }
  } else {
    onBridgeReady()
  }
}

// 支付宝支付
function handleAlipay (paySign, target) {
  target.$vux.loading.hide()
  AlipayJSBridge.call('tradePay', {
    tradeNO: paySign, // 必传，此使用方式下该字段必传
    bizType: '',                          // 非必传，默认为 “trade”
    bizSubType: '',                          // 非必传，默认为 “”
    bizContext: ''                           // 非必传，默认为H5启动选项(safePayContext)
  }, function (result) {
    if (result.resultCode == '9000') {
      AlertModule.show({
        content: `<p style="text-align:center;padding-top:10px">付款成功，请离场</p>`,
        hideOnBlur: true,
        onHide () {
          AlipayJSBridge.call('closeWebview')
        }
      })
    }
  })
}

// 成功提示
function successNotify (text) {
  Notification({
    title: '提示',
    type: 'success',
    message: text || '成功',
    duration: 1000
  })
}

// 对象深拷贝
function deepCopy (obj) {
  var result = Array.isArray(obj) ? [] : {}
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        result[key] = deepCopy(obj[key])
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}

export default {
  deepCopy,
  successNotify,
  payLast,
  handleAlipay
}



// WEBPACK FOOTER //
// ./src/tools/preset.js